import React from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface PageContentLayoutProps {
  sx?: SxProps;
  children: React.ReactNode;
}

const PageContentLayout = (props: PageContentLayoutProps) => {
  const { children, sx = [] } = props;
  return (
    <Box
      width={{
        xs: '100%',
        md: '90%',
        lg: '75%',
      }}
      py={{ xs: 1, md: 2 }}
      px={{ xs: 0, md: 3 }}
      margin="0 auto"
      sx={sx}
    >
      {children}
    </Box>
  );
};

export default PageContentLayout;
